let storage: Storage | null = null

function getStorage() {
  if (!env.client) return null
  if (!storage) {
    try {
      let key = "__test__"
      window.localStorage.setItem(key, key)
      storage = window.localStorage.getItem(key) === key ? window.localStorage : null
    } catch (e) {
      storage = window.sessionStorage
    }
  }
  if (!storage) {
    try {
      let key = "__test__"
      window.sessionStorage.setItem(key, key)
      storage = window.sessionStorage.getItem(key) === key ? window.sessionStorage : null
    } catch (e) {
      storage = window.sessionStorage
    }
  }

  return storage
}

export const safeStorage = {
  setItem(key: string, value: string) {
    if (!env.client) return
    const current = getStorage()?.getItem(key)
    if (current !== value) {
      getStorage()?.setItem(key, value)
    }
  },
  getItem(key: string) {
    if (!env.client) return null
    return getStorage()?.getItem(key)
  },
  setData<T>(key: string, value: T) {
    if (!env.client) return
    const current = getStorage()?.getItem(key)
    if (current !== value) {
      try {
        this.setItem(key, JSON.stringify(value))
      } catch (e) {}
    }
  },
  removeItem(key: string) {
    if (!env.client) return
    getStorage()?.removeItem(key)
  },
  getData<T>(key: string): T | null {
    if (!env.client) return null
    const item = this.getItem(key)
    if (item) {
      try {
        return JSON.parse(item)
      } catch (e) {
        return null
      }
    }
    return null
  },
  subscribe(keys: string[], func: (e: StorageEvent) => void) {
    const handler = (e: StorageEvent) => {
      if (e.key === null || keys.includes(e.key)) {
        func(e)
      }
    }
    window.addEventListener("storage", handler)
    return () => {
      return window.removeEventListener("storage", handler)
    }
  },
}
